export class CsvService {
	public saveDataInCSV<T>(data: Array<T>): string {
		if (data.length == 0) {
			return '';
		}
		const propertyNames = Object.keys(data[0]);
		const rowWithPropertyNames = propertyNames.join(',') + '\n';

		let csvContent = rowWithPropertyNames;
		const rows: string[] = [];

		data.forEach((item) => {
			const values: string[] = [];

			propertyNames.forEach((key) => {
				let val = item[key];

				if (val !== undefined && val !== null) {
					val = new String(val);
				} else {
					val = '';
				}
				values.push(val);
			});
			rows.push(values.join(','));
		});
		csvContent += rows.join('\n');

		return csvContent;
	}

	public importDataFromCSV<T>(csvText: string, typecheck: (x: unknown) => x is T): Array<T> {
		const propertyNames = csvText.slice(0, csvText.indexOf('\n')).split(/[,;]/);
		const dataRows = csvText.slice(csvText.indexOf('\n') + 1).split('\n');

		const dataArray = [];
		dataRows
			.filter((row) => row !== '')
			.forEach((row) => {
				const values = row.split(/[,;]/);
				const obj = new Object();

				for (let index = 0; index < propertyNames.length; index++) {
					const propertyName: string = propertyNames[index].trim();
					let val = values[index].trim();
					if (val === '') {
						val = null;
					}

					obj[propertyName] = val;
				}
				if (typecheck(obj)) dataArray.push(obj);
				else throw Error('Bad format error');
			});

		return dataArray;
	}
}
